var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.207,
    height: 18.207,
    viewBox: "0 0 18.207 18.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_buildings-2",
    "data-name": "vuesax/bold/buildings-2",
    transform: "translate(-492 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buildings-2",
    transform: "translate(492 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H18.207V18.207H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "meta_data",
    "data-name": "meta data",
    transform: "translate(-198.672 -39.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M208.473,42.276l.609.049a10.418,10.418,0,0,1,2.777.563,3.362,3.362,0,0,1,.955.516.9.9,0,0,1,.384.8,5.171,5.171,0,0,0,0,.65.868.868,0,0,1-.339.739,3.354,3.354,0,0,1-1.071.581,9.779,9.779,0,0,1-2.245.491,15.085,15.085,0,0,1-2.572.073,10.141,10.141,0,0,1-3.385-.667,4.312,4.312,0,0,1-.81-.474.816.816,0,0,1-.353-.754,5.57,5.57,0,0,0,0-.662.881.881,0,0,1,.355-.756,3.213,3.213,0,0,1,.915-.514,8.8,8.8,0,0,1,2.139-.512c.409-.051.822-.073,1.233-.109.036,0,.072-.012.108-.018Z",
    transform: "translate(-0.034)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M207.161,435.817c-.207-.016-.415-.031-.622-.049a9.664,9.664,0,0,1-2.913-.619,4.677,4.677,0,0,1-.838-.475.841.841,0,0,1-.377-.78c.016-.3,0-.605,0-.908v-.138a.292.292,0,0,1,.049.017,6.7,6.7,0,0,0,2.542.914,15.852,15.852,0,0,0,4.118.19,10.548,10.548,0,0,0,3.028-.612c.325-.127.629-.309.942-.467.024-.012.047-.028.091-.056v.174c0,.3-.011.6,0,.9a.884.884,0,0,1-.345.749,3.265,3.265,0,0,1-.993.549,9.423,9.423,0,0,1-2.29.514c-.341.038-.684.055-1.027.082a.906.906,0,0,0-.1.018Z",
    transform: "translate(-0.023 -380.973)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M202.434,214.691c.356.168.694.351,1.048.491a9.367,9.367,0,0,0,2.213.521,15.911,15.911,0,0,0,2.742.122,11.839,11.839,0,0,0,3.636-.615c.385-.14.748-.339,1.132-.515-.018-.016-.007-.011-.007-.006,0,.4,0,.81,0,1.214a.592.592,0,0,1-.214.442,3.719,3.719,0,0,1-.6.439,6.242,6.242,0,0,1-1.892.612,14.91,14.91,0,0,1-4.4.143,8.386,8.386,0,0,1-2.54-.612,4.431,4.431,0,0,1-.784-.471.817.817,0,0,1-.338-.737C202.445,215.374,202.434,215.026,202.434,214.691Z",
    transform: "translate(-0.043 -168.176)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M213.154,323.309c0,.055.007.094.007.133,0,.323-.007.646,0,.969a.825.825,0,0,1-.272.645,3.09,3.09,0,0,1-1.11.633,9.584,9.584,0,0,1-2.182.492,15.253,15.253,0,0,1-2.865.071,9.819,9.819,0,0,1-3.144-.639,4.529,4.529,0,0,1-.808-.455.864.864,0,0,1-.4-.808c.017-.3,0-.605,0-.908,0-.039,0-.078.006-.113.26.135.507.278.766.394a8.548,8.548,0,0,0,2.206.591,15.955,15.955,0,0,0,3.461.143,11,11,0,0,0,3.308-.635c.322-.125.621-.306.93-.462C213.093,323.348,213.116,323.332,213.154,323.309Z",
    transform: "translate(0 -274.135)",
    fill: "#1383d9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.c48f299cc646e5a407d05caabd3d8e48.svg";
export { ForwardRef as ReactComponent };